import React from 'react';
import './index.css'; // Import your CSS for styling

const Loader = () =>
{
    return (
        <div className="loader">
            <div className="spinner"></div>
            <div className="blur-background"></div>
        </div>
    );
};

export default Loader;